import {
  isApplicationCreated,
  isFinalizeAccountActive,
  isCredentialsSectionActive,
  isMortgageSectionActive,
  isProfileSectionActive,
  isCoapplicantSectionActive,
  isHomeDetailsSectionActive,
  isLegalSectionActive,
  isVerifyIdentitySectionActive,
} from "@/lib/util";
import { selectApplication } from "@/slices/applicationSlice";
import { selectFundmoreSSO } from "@/slices/sessionDataSlice";
import { RootState } from "@/store/dtm";
import { applicationCategory } from "@/types/applicationType";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function ApplicationTracker(props: any) {
  const credentialsSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.credentials
  );
  const addressSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.address
  );
  const finalizeAccoutSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.finalizeAccount
  );
  const coapplicantSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.coapplicant
  );
  const homeDetailsSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.propertyDetails
  );
  const mortgageSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.mortgage
  );
  const profileSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.profile
  );
  const legalTermsSectionComplete = useSelector(
    (state: RootState) => state.progress.progress.legal
  );
  const verifyIdentitySectionComplete = useSelector(
    (state: RootState) => state.progress.progress.verifyIdentity
  );

  const pathname = useLocation().pathname.toLowerCase();

  const credentialsSectionActive = isCredentialsSectionActive(pathname);
  const profileSectionActive = isProfileSectionActive(pathname);
  const mortgageSectionActive = isMortgageSectionActive(pathname);
  const homeDetailsSectionActive = isHomeDetailsSectionActive(pathname);
  const finalizeAccountSectionActive = isFinalizeAccountActive(pathname);
  const coapplicantSectionActive = isCoapplicantSectionActive(pathname);
  const legalTermsSectionActive = isLegalSectionActive(pathname);
  const verifyIdentitySectionActive = isVerifyIdentitySectionActive(pathname);
  const isComplete = isApplicationCreated(pathname);

  const application = useSelector(selectApplication).application;
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );
  const sessionData = useSelector(selectFundmoreSSO);

  return (
    <>
      <div>
        <div>
          <nav
            className="hs-accordion-group sm:p-6 w-full flex flex-col flex-wrap mt-10"
            data-hs-accordion-always-open
          >
            <ul className="space-y-1.5">
              <li className={clsx(credentialsSectionActive ? "tracker-active-light" : "")}>
                <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                  <div
                    className={clsx(
                      "tracker",
                      credentialsSectionActive ? "tracker-active" : "",
                      credentialsSectionComplete ? "tracker-complete" : ""
                    )}
                  >
                    <span
                      className={clsx(
                        "step-count",
                        credentialsSectionActive ? "active" : "",
                        credentialsSectionComplete ? "hidden" : ""
                      )}
                    >
                      1
                    </span>
                    <span
                      className={clsx(credentialsSectionComplete ? "" : "hidden")}
                    >
                      <img
                        src="assets/task-finished-icon.svg"
                        alt="section complete"
                        className="mt-2 ml-1.5"
                        width={11}
                        height={8}
                      />
                    </span>
                  </div>
                  <p
                    className={clsx(
                      credentialsSectionActive ? "active" : "",
                      credentialsSectionComplete ? "complete" : ""
                    )}
                    style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                  >
                    Set up your profile
                  </p>
                </div>
              </li>
              {sessionData != undefined && sessionData.request != ""
                ?
                <li>
                  <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                    <div className={clsx("tracker")}>
                      <span className={clsx("step-count")}>
                        2
                      </span>
                    </div>
                    <p style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                    >
                      Submit Documents
                    </p>
                  </div>
                </li>
                :
                <>
                  <li className={clsx(mortgageSectionActive ? "tracker-active-light" : "")}>
                    <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                      <div
                        className={clsx(
                          "tracker",
                          mortgageSectionActive ? "tracker-active" : "",
                          mortgageSectionComplete ? "tracker-complete" : ""
                        )}
                      >
                        <span
                          className={clsx(
                            "step-count",
                            mortgageSectionActive ? "active" : "",
                            mortgageSectionComplete ? "hidden" : ""
                          )}
                        >
                          2
                        </span>
                        <span
                          className={clsx(mortgageSectionComplete ? "" : "hidden")}
                        >
                          <img
                            src="assets/task-finished-icon.svg"
                            alt="section complete"
                            className="mt-2 ml-1.5"
                            width={11}
                            height={8}
                          />
                        </span>
                      </div>
                      <p
                        className={clsx(
                          mortgageSectionActive ? "active" : "",
                          mortgageSectionComplete ? "complete" : ""
                        )}
                        style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                      >
                        Your new mortgage
                      </p>
                    </div>
                  </li>
                  <li className={clsx(profileSectionActive ? "tracker-active-light" : "")}>
                    <div className="flex items-center gap-x-3.5  text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                      <div
                        className={clsx(
                          "tracker",
                          profileSectionActive ? "tracker-active" : "",
                          profileSectionComplete || isComplete ? "tracker-complete" : ""
                        )}
                      >
                        <span
                          className={clsx(
                            "step-count",
                            profileSectionActive ? "active" : "",
                            profileSectionComplete ? "hidden" : ""
                          )}
                        >
                          3
                        </span>
                        <span
                          className={clsx(
                            profileSectionComplete ? "" : "hidden"
                          )}
                        >
                          <img
                            src="assets/task-finished-icon.svg"
                            alt="section complete"
                            className="mt-2 ml-1.5"
                            width={11}
                            height={8}
                          />
                        </span>
                      </div>
                      <p
                        className={clsx(
                          profileSectionActive ? "active" : "",
                          profileSectionComplete ? "complete" : ""
                        )}
                        style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                      >
                        Build your profile
                      </p>
                    </div>
                  </li>
                  <li className={clsx(homeDetailsSectionActive ? "tracker-active-light" : "")}>
                    <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                      <div
                        className={clsx(
                          "tracker",
                          homeDetailsSectionActive ? "tracker-active" : "",
                          homeDetailsSectionComplete || isComplete ? "tracker-complete" : ""
                        )}
                      >
                        <span
                          className={clsx(
                            "step-count",
                            homeDetailsSectionActive ? "active" : "",
                            homeDetailsSectionComplete || isComplete ? "hidden" : ""
                          )}
                        >
                          4
                        </span>
                        <span
                          className={clsx(
                            homeDetailsSectionComplete || isComplete ? "" : "hidden"
                          )}
                        >
                          <img
                            src="assets/task-finished-icon.svg"
                            alt="section complete"
                            className="mt-2 ml-1.5"
                            width={11}
                            height={8}
                          />
                        </span>
                      </div>
                      <p
                        className={clsx(
                          homeDetailsSectionActive ? "active" : "",
                          homeDetailsSectionComplete || isComplete ? "complete" : ""
                        )}
                        style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                      >
                        Your {application.applicationCategory == applicationCategory.Buy ? "new" : ""} home
                      </p>
                    </div>
                  </li>
                  <li className={clsx(finalizeAccountSectionActive ? "tracker-active-light" : "")}>
                    <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                      <div
                        className={clsx(
                          "tracker",
                          finalizeAccountSectionActive ? "tracker-active" : "",
                          finalizeAccoutSectionComplete || isComplete ? "tracker-complete" : ""
                        )}
                      >
                        <span
                          className={clsx(
                            "step-count",
                            finalizeAccountSectionActive ? "active" : "",
                            finalizeAccoutSectionComplete || isComplete ? "hidden" : ""
                          )}
                        >
                          5
                        </span>
                        <span
                          className={clsx(
                            finalizeAccoutSectionComplete || isComplete ? "" : "hidden"
                          )}
                        >
                          <img
                            src="assets/task-finished-icon.svg"
                            alt="section complete"
                            className="mt-2 ml-1.5"
                            width={11}
                            height={8}
                          />
                        </span>
                      </div>
                      <p
                        className={clsx(
                          finalizeAccountSectionActive ? "active" : "",
                          finalizeAccoutSectionComplete || isComplete ? "complete" : ""
                        )}
                        style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                      >
                        Review your application
                      </p>
                    </div>
                  </li>
                  {applicant.isProspect &&
                    <li className={clsx(legalTermsSectionActive ? "tracker-active-light" : "")}>
                      <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                        <div
                          className={clsx(
                            "tracker",
                            legalTermsSectionActive ? "tracker-active" : "",
                            legalTermsSectionComplete ? "tracker-complete" : ""
                          )}
                        >
                          <span
                            className={clsx(
                              "step-count",
                              legalTermsSectionActive ? "active" : "",
                              legalTermsSectionComplete ? "hidden" : ""
                            )}
                          >
                            6
                          </span>
                          <span
                            className={clsx(legalTermsSectionComplete ? "" : "hidden")}
                          >
                            <img
                              src="assets/task-finished-icon.svg"
                              alt="section complete"
                              className="mt-2 ml-1.5"
                              width={11}
                              height={8}
                            />
                          </span>
                        </div>
                        <p
                          className={clsx(
                            legalTermsSectionActive ? "active" : "",
                            legalTermsSectionComplete ? "complete" : ""
                          )}
                          style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                        >
                          Review legal terms
                        </p>
                      </div>
                    </li>
                  }
                  {applicant.isProspect &&
                    <li className={clsx(verifyIdentitySectionActive ? "tracker-active-light" : "")}>
                      <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{ paddingLeft: 8 }}>
                        <div
                          className={clsx(
                            "tracker",
                            verifyIdentitySectionActive ? "tracker-active" : "",
                            verifyIdentitySectionComplete ? "tracker-complete" : ""
                          )}
                        >
                          <span
                            className={clsx(
                              "step-count",
                              verifyIdentitySectionActive ? "active" : "",
                              verifyIdentitySectionComplete ? "hidden" : ""
                            )}
                          >
                            7
                          </span>
                          <span
                            className={clsx(verifyIdentitySectionComplete ? "" : "hidden")}
                          >
                            <img
                              src="assets/task-finished-icon.svg"
                              alt="section complete"
                              className="mt-2 ml-1.5"
                              width={11}
                              height={8}
                            />
                          </span>
                        </div>
                        <p
                          className={clsx(
                            verifyIdentitySectionActive ? "active" : "",
                            verifyIdentitySectionComplete ? "complete" : ""
                          )}
                          style={{ marginTop: 0, paddingTop: 4, paddingBottom: 4 }}
                        >
                          Verify your identity
                        </p>
                      </div>
                    </li>
                  }
                </>}

            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
